/* eslint-disable no-alert */
import React from 'react';

import { twMerge } from 'tailwind-merge';

import { useAvailableSingleCallJobs } from 'state/context/freelancer/FreelancerAvailableJobs';

import { useGetFreelancerDetails } from 'state/remote/remote-freelancer/use-get-freelancer-details';

import Typography from 'components/typography/typography';

import JobCard from './JobCard';

import DateHolder from './DateHolder';

const JobList: React.FC = () => {
  const { availablejobs, warningMessage } = useAvailableSingleCallJobs();

  const { data, isLoading, error } = useGetFreelancerDetails();

  const messageClassName = twMerge(
    'container flex justify-start items-center',
    'text-brown border-slate300 mt-10 pl-4',
    'border rounded-md  w-full h-16 bg-pink mb-48',
  );

  if (availablejobs.isLoading || isLoading)
    return (
      <div className="flex flex-col justify-center mt-16 items-center w-full h-full bg-white" />
    );

  if (warningMessage.length > 0)
    return (
      <Typography
        variant="body-large-bold"
        as="h5"
        className={messageClassName}
      >
        {warningMessage}
      </Typography>
    );

  if (availablejobs.error)
    return (
      <div>
        <Typography
          variant="body-large-bold"
          as="h5"
          className={messageClassName}
        >
          {availablejobs.error.message}
        </Typography>
      </div>
    );

  if (error)
    return (
      <Typography
        variant="body-large-bold"
        as="h5"
        className={messageClassName}
      >
        {error}
      </Typography>
    );

  if (availablejobs.data.length > 0) {
    return (
      <div className="container px-0 h-full pb-32 mx-2 md:mx-0">
        {availablejobs.data.map(([date, jobs], index) => {
          return (
            <>
              <DateHolder
                index={index}
                key={`${date}-${jobs?.[0].id.toString()}`}
                date={date}
              />
              {jobs &&
                jobs.map((job) => {
                  return (
                    <JobCard
                      key={`${job.id.toString()}-${job.date}`}
                      job={job}
                      vatExempt={data?.btw_keuze !== 3}
                    />
                  );
                })}
            </>
          );
        })}
      </div>
    );
  }
  return <></>;
};

export default JobList;
